<div class="page">
    <div class="page-header">
        <div class="header-left">
            <mat-icon class="back-icon" routerLink="/categorys">arrow_back</mat-icon>
            <h3>{{ 'category.update.title' | translate }}</h3>
        </div>
    </div>

    <div class="form-card">
        <h4 class="section-title">{{ 'category.update.basicData' | translate }}</h4>
        <form novalidate [formGroup]="categoryForm!">
            <div class="form-row">
                <label for="name">{{ 'category.update.name' | translate }} <span class="required">*</span></label>
                <div class="form-input">
                    <input formControlName="name" id="name" type="text" required [(ngModel)]="category.name" />
                </div>
            </div>
        </form>
    </div>

    <div class="form-card">
        <h4 class="section-title">{{ 'category.update.elements' | translate }}</h4>
        <div class="drag-and-drop-container">
            <div class="search-main-container">
                <div class="search-bar">
                    <mat-icon fontIcon="search" />
                    <input placeholder="{{ 'category.update.searchPlaceholder' | translate }}" type="search" [(ngModel)]="searchText" />
                </div>
                <div class="category-info">
                    <span>{{ category.name }} — {{ 'category.update.elementCount' | translate }}: {{ updateableProducts.length }}</span>
                </div>
            </div>
            <div class="drag-and-drop">
                <div class="products-panel">
                    <h5 class="panel-title">{{ 'category.update.availableProducts' | translate }}</h5>
                    <div class="products-list">
                        @for (product of productsExcludingCategory | filter: searchText; track product) {
                            <div class="product-item">
                                <span>{{ product.author + ': ' + product.title }}</span>
                                <mat-icon class="action-icon action-icon--add" (click)="addProductToCategory(product)">add_circle_outline</mat-icon>
                            </div>
                        }
                    </div>
                </div>
                <div class="products-panel">
                    <h5 class="panel-title">{{ 'category.update.categoryProducts' | translate }}</h5>
                    <div cdkDropList class="products-list" (cdkDropListDropped)="drop($event)">
                        @for (product of updateableProducts; track product; let i = $index) {
                            <div cdkDrag class="product-item">
                                <mat-icon class="drag-handle" fontIcon="drag_indicator" />
                                <b class="order-number">{{ i + 1 }}</b>
                                <span>{{ product.author + ': ' + product.title }}</span>
                                <mat-icon class="action-icon action-icon--remove" (click)="deleteFromCategoryProductList(product)">remove_circle_outline</mat-icon>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>

        <div class="submit-row">
            <button type="button" class="btn btn-submit" [disabled]="!categoryForm?.valid" (click)="updateCategory()">
                {{ 'category.update.submitButton' | translate }}
            </button>
        </div>
    </div>

    <div class="form-card">
        <h4 class="section-title">{{ 'homeConfig.updateInfoBox' | translate }}</h4>
        <div class="form-row full-width">
            <label for="categoryOfferLines">{{ 'homeConfig.updateInfoBoxDescription' | translate }}</label>
            <div class="form-input">
                <textarea id="categoryOfferLines" rows="5" [(ngModel)]="offerLinesValue"></textarea>
            </div>
        </div>
        <div class="form-row">
            <label>{{ 'homeConfig.updateActive' | translate }}</label>
            <div class="form-input checkbox-row">
                <mat-checkbox
                    [ngModel]="offerLinesActive"
                    [disabled]="!offerLinesValue.trim()"
                    (change)="onChangeOfferLinesActive()"
                />
            </div>
        </div>
        <div class="submit-row">
            <button type="button" class="btn btn-submit" [disabled]="!offerLinesValue.trim()" (click)="updateOfferLines()">
                {{ 'homeConfig.updateInfoBoxSubmitButton' | translate }}
            </button>
        </div>
    </div>
</div>
